module.exports = __webpack_public_path__ + "img/ce4ff98.jpg";